import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { featuresData } from '@/data/mock';
import { Briefcase, LayoutDashboard, UserCheck } from 'lucide-react';

const iconMap = {
  Briefcase,
  LayoutDashboard,
  UserCheck,
};

export const FeaturesSection = () => {
  return (
    <section className="relative py-24 bg-slate-950">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/30 to-transparent" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-indigo-500/10 text-indigo-400 text-sm font-medium rounded-full mb-4">
            Features
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Everything you need to hire with confidence
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Built for modern recruiting teams who value quality over quantity
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {featuresData.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <Card
                key={index}
                className="bg-slate-900/50 border-slate-800/50 hover:border-indigo-500/30 transition-all duration-300 group"
              >
                <CardContent className="p-8">
                  <div className="w-14 h-14 rounded-xl bg-indigo-500/10 flex items-center justify-center mb-6 group-hover:bg-indigo-500/20 transition-colors">
                    <Icon size={28} className="text-indigo-400" />
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
                  <p className="text-cyan-400 text-sm font-medium mb-3">{feature.description}</p>
                  <p className="text-slate-400">{feature.details}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
